import React, { useContext } from "react";
import { useDropzone } from "react-dropzone";
import EditAttachments from "./EditAttachments";
import { popupcontext } from "../../../context/Popupscontext";
import { toast } from "react-toastify";
import trans from "../../../utils";
import * as XLSX from "xlsx"; // Import at the top

export default function UploadFile({
	addData,
	name,
	EditableAttachments,
	type,
}) {
	let { isEditing, setAttachments } = useContext(popupcontext);
	const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
		noClick: true,
		noKeyboard: true,
		accept: {
			"application/vnd.ms-excel": [],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
		},
		onDropAccepted: async (files) => {
			const file = files[0];

			const reader = new FileReader();
			reader.onload = (e) => {
				const data = new Uint8Array(e.target.result);
				const workbook = XLSX.read(data, { type: "array" });
				const worksheet = workbook.Sheets[workbook.SheetNames[0]];
				const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

				addData?.setFieldValue("file", files);
				addData?.setFieldValue("parsedData", jsonData); // Save parsed data
				setAttachments(files);
			};
			reader.readAsArrayBuffer(file);
		},
		onDropRejected: (rejectedFiles) => {
			toast.info(trans("Only XLSX and CSV are allowed!"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		},
	});

	const hasFiles = acceptedFiles.length > 0;

	const files = acceptedFiles.map((file) => (
		<li key={file.path}>
			{file.path} - {file.size} bytes
		</li>
	));

	return (
		<>
			<div onClick={open} className="mb-2">
				<p className="form-label">{trans("Upload File")}</p>
				<div
					{...getRootProps({
						className: `dropzone mt-0 uploadFiles`,
					})}
				>
					<input {...getInputProps()} />
					<p>
						{trans("Drag files here or")}{" "}
						<span style={{ color: "#2E9245", fontWeight: 500 }}>
							{trans("Upload")}
						</span>
					</p>
				</div>
				{hasFiles && (
					<aside>
						<h6 className="mt-2">{trans("Files")}</h6>
						<ul>{files}</ul>
					</aside>
				)}
			</div>
		</>
	);
}
